import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";

export interface AdminsQueryParams {
  id?: string;
  search?: string;
  role?: string;
  limit?: number;
  page?: number;
}

export const useGetAdminsQuery = ({
  id,
  search,
  role,
  limit,
  page,
}: AdminsQueryParams) => {
  const token = localStorage.getItem("BETTY_ADMIN_USER_TOKEN");

  const queryParams = new URLSearchParams();

  if (search) queryParams.append("search", search);
  if (role) queryParams.append("role", role);
  if (limit) queryParams.append("limit", limit.toString());
  if (page) queryParams.append("page", page.toString());

  const url = id ? `/admins/${id}` : `/admins?${queryParams.toString()}`;

  return useQuery({
    queryKey: ["useGetAdminsQuery", { id, search, role, limit, page }],
    queryFn: () =>
      axiosInstance
        .get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data),

    // onError: (error: any) => {
    //   message.error(error?.response?.data?.message);
    // },
    enabled: !!token,
  });
};
